import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { EventCardData, ExhibitorCardData, HtmlElementHelper, TabClickEvent } from '@planone/bau365/util-fair-data';
import { LinkClickEvent } from '@planone/shared/util-interfaces';

import * as DataAccessEventsPageActions from './data-access-events.page.actions';

@Injectable()
export class DataAccessEventsPageFacade {
  constructor(private readonly store: Store) {}

  shareButtonClicked(
    network: string,
    event: EventCardData,
    exhibitor: ExhibitorCardData,
    pageContext: string,
    context: string
  ) {
    this.store.dispatch(
      DataAccessEventsPageActions.eventsShareButtonClicked({
        network: network,
        event: event,
        exhibitor: exhibitor,
        pageContext: pageContext,
        context: context,
      })
    );
  }

  shareDialogOpened(contentType: string, pageContext: string, context: string, event: EventCardData) {
    this.store.dispatch(
      DataAccessEventsPageActions.eventsShareDialogOpened({
        contentType: contentType,
        pageContext: pageContext,
        context: context,
        event: event,
      })
    );
  }

  pageView(event_id: string, fair_id: string) {
    this.store.dispatch(DataAccessEventsPageActions.eventsPageView({ event_id, fair_id }));
  }

  trackedItemClicked(clickedLinkInfo: LinkClickEvent) {
    this.store.dispatch(
      DataAccessEventsPageActions.eventsTrackedItemClicked({
        ...clickedLinkInfo,
        htmlElement: HtmlElementHelper.flattenObject(clickedLinkInfo.htmlElement),
      })
    );
  }

  tabClicked(tabClickInfo: TabClickEvent) {
    this.store.dispatch(DataAccessEventsPageActions.eventsTabClicked(tabClickInfo));
  }

  contributorPageView(event_id: string, contributor_id: string) {
    this.store.dispatch(DataAccessEventsPageActions.eventsContributorPageView({ event_id, contributor_id }));
  }
}
